import CampaignIcon from "@mui/icons-material/Whatshot";
import CampaignChallengeList from "./CampaignChallengeList";
import CampaignChallengeEdit from "./CampaignChallengeEdit";
import CampaignChallengeCreate from "./CampaignChallengeCreate";

const CampaignChallengeResourceProps = {
	name: "edge_campaign_challenge",
	list: CampaignChallengeList,
	edit: CampaignChallengeEdit,
	create: CampaignChallengeCreate,
};

export const CampaignChallengeMenuProps = {
	to: "/edge_campaign_challenge",
	primaryText: "Campagnes > Défis",
	icon: CampaignIcon,

};

export default CampaignChallengeResourceProps;
